'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _themeSections = require('@shopify/theme-sections');

require('../sections/hair-stories');

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HairStories = function () {
  function HairStories(el) {
    (0, _classCallCheck3.default)(this, HairStories);

    this.classes = {
      imageContainer: 'js-HairStories_ImageContainer',
      imageTrack: 'js-HairStories_ImageTrack',
      bottomedOutImageContainer: 'js-HairStories_ImageContainer-bottomedOut',
      fixedImageContainer: 'js-HairStories_ImageContainer-fixed',
      hiddenImageContainer: 'js-HairStories_ImageContainer-hidden',
      section: 'js-HairStories_Fixed',
      productsContainer: 'js-HairStories_Products',
      product: 'js-HairStories_Product'
    };

    this.els = {
      el: el,
      fixedSections: (0, _functional.getElements)('.' + this.classes.section),
      productsContainer: (0, _functional.getElement)('.' + this.classes.productsContainer),
      products: (0, _functional.getElements)('.' + this.classes.product)
    };

    this.isTicking = false;
    this.lastKnownY = 0;

    this.fixedGroups = this.setupFixedGroups();
    this.products = this.setupProducts();

    this.onScroll = this.onScroll.bind(this);
    this.scrollUpdate = this.scrollUpdate.bind(this);

    this.setupListeners();

    (0, _themeSections.load)('hair-story');
  }

  (0, _createClass3.default)(HairStories, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      window.addEventListener('scroll', this.onScroll);

      var resizeFnc = function resizeFnc() {
        _this.products = _this.setupProducts();
      };
      window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = window.scrollY;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.scrollUpdate);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'scrollUpdate',
    value: function scrollUpdate() {
      var _this2 = this;

      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      this.fixedGroups.filter(function (group) {
        return group.hasFixedBackgrounds;
      }).forEach(function (group) {
        group.activeFixedBackground = group.fixedBackgrounds.reduce(function (acc, fixedBackground, index) {
          return _this2.lastKnownY > fixedBackground.triggerPoint ? index : acc;
        }, 0);
      });

      // Products start at the top of the section, 1 of the products is offset by an amount
      // As the section get's in to the viewport they should start coming down the page with the scroll
      // They should "bottom out" at the bottom of the section
      this.products.forEach(function (product) {
        var amountToMoveBy = _this2.lastKnownY <= product.startPoint ? 0 : _this2.lastKnownY >= product.endPoint ? product.amountNeededToMove : product.amountNeededToMove * ((_this2.lastKnownY - product.startPoint) / product.difference);

        product.el.style.transform = 'translateY(' + amountToMoveBy + 'px)';
      });
    }
  }, {
    key: 'setupFixedGroups',
    value: function setupFixedGroups() {
      var _this3 = this;

      return this.els.fixedSections.map(function (section) {
        if (section.dataset.hasBeenProcessed === 'true') return;

        var _section$dataset = section.dataset,
            wantedColumn = _section$dataset.moduleFixedColumn,
            wantedImage = _section$dataset.moduleFixedImage;

        var connectedSections = _this3.findConnectedSections(section, wantedColumn, wantedImage, [section]);

        return {
          wantedColumn: wantedColumn,
          wantedImage: wantedImage,
          sectionElements: connectedSections
        };
      }).filter(function (connectedSection) {
        return connectedSection && connectedSection.sectionElements.length > 1;
      }).map(function (group) {
        _this3.setupImageTrack(group);

        var hasFadingBackgroundColours = group.sectionElements.map(function (sectionElement) {
          var fixedBackgroundStyleElement = (0, _functional.getElement)('[data-module-fixed-background-style]', { context: sectionElement });

          return fixedBackgroundStyleElement && fixedBackgroundStyleElement.dataset.moduleFixedBackgroundStyle !== 'none';
        }).every(function (bool) {
          return bool;
        });

        if (hasFadingBackgroundColours) {
          _this3.setupFadingBackgroundColours(group);
        } else {
          group.hasFixedBackgrounds = false;
        }

        // Finally hide all but the first image container
        group.sectionElements.forEach(function (section, index) {
          if (index === 0) return;

          var imageContainer = (0, _functional.getElement)('.' + _this3.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: section });
          imageContainer.classList.add(_this3.classes.hiddenImageContainer);
        });

        return group;
      });
    }
  }, {
    key: 'findConnectedSections',
    value: function findConnectedSections(section, wantedColumn, wantedImage, sections) {
      var nextSection = section.nextElementSibling;
      var wantedImageContainerNode = (0, _functional.getElement)('.' + this.classes.imageContainer + '[data-module-image-id=\'' + wantedImage + '\'][data-module-image-column=\'' + wantedColumn + '\']', { context: nextSection });

      if (wantedImageContainerNode) {
        sections.push(nextSection);

        section.dataset.hasBeenProcessed = 'true';

        this.findConnectedSections(nextSection, wantedColumn, wantedImage, sections);
      }

      return sections;
    }
  }, {
    key: 'setupImageTrack',
    value: function setupImageTrack(group) {
      var imageTrack = (0, _functional.getElement)('.' + this.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: group.sectionElements[0] }).closest('.' + this.classes.imageTrack);
      imageTrack.style.height = 100 * group.sectionElements.length + 'vh';
    }
  }, {
    key: 'setupFadingBackgroundColours',
    value: function setupFadingBackgroundColours(group) {
      var imageTrack = (0, _functional.getElement)('.' + this.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: group.sectionElements[0] }).closest('.' + this.classes.imageTrack);

      var fixedBackgrounds = group.sectionElements.map(function (sectionElement) {
        var fixedBackgroundStyleElement = (0, _functional.getElement)('[data-module-fixed-background-style]', { context: sectionElement });
        var style = fixedBackgroundStyleElement.dataset.moduleFixedBackgroundStyle;

        return style;
      }).map(function (style, index) {
        var backgroundElement = (0, _functional.createElement)('div', {
          class: 'sec-Split_ImageTrackBackground sec-Split_ImageTrackBackground-style' + (style.charAt(0).toUpperCase() + style.substr(1)),
          style: 'opacity: ' + (index === 0 ? 1 : 0)
        });

        imageTrack.appendChild(backgroundElement);

        var triggerPoint = (0, _utils.getOffsetTop)(backgroundElement) + index * (window.innerHeight / 2);

        return {
          triggerPoint: triggerPoint,
          element: backgroundElement
        };
      });

      group.hasFixedBackgrounds = true;
      group.fixedBackgrounds = fixedBackgrounds;

      group._activeFixedBackground = null;
      Object.defineProperty(group, 'activeFixedBackground', {
        get: function get() {
          return this._activeFixedBackground;
        },
        set: function set(value) {
          this._activeFixedBackground = value;

          this.fixedBackgrounds.forEach(function (fixedBackground, index) {
            fixedBackground.element.style.opacity = index === value ? 1 : 0;
          });
        }
      });
    }
  }, {
    key: 'setupProducts',
    value: function setupProducts() {
      var referenceNode = (0, _functional.getElement)('.sec-Split_Products');
      var moveableArea = referenceNode.offsetHeight - (0, _functional.heightWithoutPadding)(referenceNode) - ((0, _functional.getElement)('.sec-Split_Products .sec-Split_Title').offsetHeight + (0, _functional.styleToNumber)(window.getComputedStyle((0, _functional.getElement)('.sec-Split_Products .sec-Split_Title')).marginBottom));
      var startPoint = (0, _utils.getOffsetTop)(referenceNode) - window.innerHeight / 8;
      var endPoint = (0, _utils.getOffsetTop)(referenceNode) + window.innerHeight / 2;
      var difference = endPoint - startPoint;

      return this.els.products.map(function (el) {
        var amountNeededToMove = moveableArea - el.offsetHeight;

        return {
          el: el,
          startPoint: startPoint,
          endPoint: endPoint,
          difference: difference,
          amountNeededToMove: amountNeededToMove
        };
      });
    }
  }]);
  return HairStories;
}();

exports.default = HairStories;